import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export type CoreminiChangeWarningModalProps = {
    mode: 'single' | 'bulk'
    deviceName?: string
    deviceUpdateName?: string
    actual?: string | null
    expected?: string | null
    totalCount?: number
    changeCount?: number
    skipCount?: number
    disabled?: boolean
    onCancel: () => void
    onContinue: () => void
    onSkipCoreminiChanges?: () => void
}

const formatCoreminiRange = (actual?: string | null, expected?: string | null) => {
    if (actual && expected) {
        return ` from ${actual} to ${expected}`
    }
    if (expected) {
        return ` to ${expected}`
    }
    return ''
}

const CoreminiChangeWarningModal: React.FC<CoreminiChangeWarningModalProps> = ({
    mode,
    deviceName,
    deviceUpdateName,
    actual,
    expected,
    totalCount = 0,
    changeCount = 0,
    skipCount = 0,
    disabled = false,
    onCancel,
    onContinue,
    onSkipCoreminiChanges
}) => {
    const title = 'Coremini change warning'
    const body = mode === 'single'
        ? `Sending ${deviceUpdateName} to ${deviceName} will change the Coremini version${formatCoreminiRange(actual, expected)} and will delete data on the device.`
        : `${changeCount} of ${totalCount} ${totalCount === 1 ? 'device' : 'devices'} will change Coremini. Those updates will delete data on the device.`

    return (
        <Modal
            className="coremini-change-warning-modal"
            isOpen={true}
            toggle={disabled ? undefined : onCancel}
        >
            <ModalHeader id="coremini-change-warning-title">{title}</ModalHeader>
            <ModalBody>
                <p className="mb-0">{body}</p>
            </ModalBody>
            <ModalFooter className="coremini-change-warning-footer">
                <Button
                    className="coremini-warning-btn coremini-warning-btn-cancel"
                    disabled={disabled}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                {mode === 'bulk' && (
                    <Button
                        className="coremini-warning-btn coremini-warning-btn-skip"
                        disabled={disabled || skipCount === 0}
                        onClick={onSkipCoreminiChanges}
                    >
                        Update devices without a Coremini change
                    </Button>
                )}
                <Button
                    className="coremini-warning-btn coremini-warning-btn-continue"
                    disabled={disabled}
                    onClick={onContinue}
                >
                    {mode === 'bulk' ? 'Continue all' : 'Continue'}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CoreminiChangeWarningModal
